export const getPrivateQueryParam = () => {
  return "form_private_plans=true";
}